module.exports = __webpack_public_path__ + "static/media/image-992.b267c1f3.webp";